export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20entertainment%20platform%20concept%2C%20abstract%20floating%20geometric%20film%20frames%20with%20warm%20golden%20orange%20glow%20on%20dark%20background%2C%20elegant%20cinematic%20aesthetic%2C%20soft%20atmospheric%20lighting%2C%20premium%20brand%20visual%2C%20no%20text%20no%20people&width=1000&height=750&seq=about-visual&orientation=landscape"
                alt="关于嫩草视频"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
              平台介绍
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于嫩草
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                嫩草视频是一个专注于高清影视资源聚合的在线观影平台，致力于为广大用户提供流畅、免费、高品质的观影体验。平台聚合了香蕉视频、红桃视频、蜜桃视频、91视频等多家优质影视资源站点，覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容。
              </p>
              <p>
                我们深知用户对于观影流畅度和画质的追求，因此嫩草视频采用多线路智能调度技术，确保每一次播放都能自动匹配最优节点，实现超清画质下不卡顿、不缓冲的观影体验。无论是最新上映的大片，还是追更中的热播剧集，你都能在这里一站找到完整版资源。
              </p>
              <p>
                平台内容每日同步更新，紧跟各大视频平台播出节奏，让你不错过任何精彩瞬间。全站无需下载、无需注册，打开即看，真正实现零门槛的便捷观影。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100">
                  <i className="ri-movie-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-lg font-bold text-foreground-950">10,000+</div>
                  <div className="text-xs text-foreground-500">影视资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100">
                  <i className="ri-user-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-lg font-bold text-foreground-950">500万+</div>
                  <div className="text-xs text-foreground-500">月活用户</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100">
                  <i className="ri-time-line text-secondary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-lg font-bold text-foreground-950">7×24h</div>
                  <div className="text-xs text-foreground-500">不间断更新</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}